import { api } from '@/api';

export const QueueService = {
    list: api('/api/queues', 'get'),
};
